export default __webpack_public_path__ + "static/media/college-cat.ee61e6a7.svg";